module.exports = __webpack_public_path__ + "img/collection-gray.svg";